export default "__VITE_ASSET__98vNeFV2__"